<template>
  <div style="background-color:#fff;">
    <!-- 顶部 标题栏 -->
    <van-nav-bar left-arrow style="background-color:#393a3f;position:relative;" @click-left="handelLeftMenuFunc()">
        <template #left>
            <van-icon name="arrow-left" size="18" color='white' />
        </template>
        <template #title>
            <span style="color: white;">云影像</span>
        </template>
    </van-nav-bar>
    <iframe id="bdIframe" frameborder=0 scrolling=auto :src="WPacsUrl"></iframe>
  </div>
</template>
<script>

import { GetGoBackUrlParms } from '../../utils/cacheUtils'
import {GetWPACSPrePath} from '@/api/CloudFilmService'
import { DecryptAES } from '../../utils/stringUtils'
export default {
  data() {
    return {
      WPacsUrl: ''
    };
  },
  activated() {
    this.$nextTick(() => {
        GetWPACSPrePath({ExaminationID:DecryptAES(this.$route.query.ExaminationID),PatientID:DecryptAES(this.$route.query.PatientID),WebPacsURL:DecryptAES(this.$route.query.WebPacsURL)}).then(res=>{
            if(res.Success){
            this.WPacsUrl =res.Result;
            }
        })
    });
  },
  mounted() {
    /**
     * iframe-宽高自适应显示
     */
    const oIframe = document.getElementById('bdIframe');
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    oIframe.style.width = (Number(deviceWidth)) + 'px'; //数字是页面布局宽度差值
    oIframe.style.height = (Number(deviceHeight) - 55) + 'px'; //数字是页面布局高度差
  },
  methods: {
    handelLeftMenuFunc(){
        this.$router.push({path:'/reportView?'+GetGoBackUrlParms()})
    }
  }
};
</script>